import { HTTP_TOKEN_REPORT } from "./http";

export const getPagesReport = (params) => {
  return HTTP_TOKEN_REPORT.get("report-page", { params }).then((result) => {
    return result.data;
  });
};
